import { Suspense, lazy, useEffect } from "react";
import { Route, Switch } from "react-router";
import "antd/dist/antd.css";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollToTop from "./utils/ScrollToTop";
import Loader from "./components/Loader";
import { Modal } from "./useStyles";
import * as PageURL from "./utils/pageUrl";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { getMessaging, onMessage } from "firebase/messaging";
import { /*  getFirebaseToken, */ requestPermission } from "./utils/useFirebaseUtils";
import 'sweetalert2/src/sweetalert2.scss'
import ProtectedRoute from './utils/protectedRoute';
import Routes from "./utils/dashboard";
import "react-nprogress/nprogress.css"


function Display({ title, body, image }) {
	return (
		<div>
			<h4>{title}</h4>
			<p>{body}</p>
			{image && <img src={image} style={{ width: "50%" }} alt="notification" />}
		</div>
	);
}

AOS.init();
function App() {
	const Home = lazy(() => import("./routes/Home"));
	// const Search = lazy(() => import('./routes/Transaction/Search'))
	// const Transaction = lazy(() => import("./routes/Transaction"));
	const Success = lazy(() => import("./routes/Success"));
	
	const Converter = lazy(() => import("./components/Converter"));
	

	// Auth
	const Login = lazy(() => import("./routes/Auth/Login"));
	const Register = lazy(() => import("./routes/Auth/Register"));
	const ForgotPage = lazy(() => import("./routes/Auth/ForgotPassword"));
  const Page404 = lazy(() => import("./components/404"));


	useEffect(() => {
		// getFirebaseToken();
		requestPermission();
	}, []);

	const messaging = getMessaging();
	onMessage(messaging, (payload) => {
		if (payload) {
			toast.info(<Display title={payload.data.title} body={payload.data.body} image={payload.data.image ?? null} />);
		}
	});

	return (
		<div className="App overflow-x-hidden">
			<ScrollToTop />
			<ToastContainer />
			<Suspense
				fallback={
					<Modal className="grid h-screen place-items-center" >
						<Loader />
					</Modal>
				}
			>
				<Switch>
					<Route exact path={PageURL.HOMEPAGE} component={Home} />
					{/* <Route path={PageURL.SEARCH} component={Search} /> */}
					{/* <Route path={PageURL.TRANSACTION} component={Transaction} /> */}
					{/* <Route exact path={PageUrl.MORE_SUMMARY} render={(props) => {
              if (props.match.  .type === "all") return (<AllTrans />)
              else return (<MoreDetails />)
            }
            }
            /> */}
					<Route exact path={PageURL.SUCCESS} component={Success} />
					<Route exact path={PageURL.CONVERTER} component={Converter} />


					{/* Auth pages */}
					<Route exact path={PageURL.LOGIN} component={Login} />
					<Route exact path={PageURL.REGISTER} component={Register} />
					<Route exact path={PageURL.FORGOT_PASSWORD} component={ForgotPage} />

					<ProtectedRoute component={Routes} />
					<Route path="*" component={Page404} />
					{/* <Routes /> */}
				
				</Switch>
			</Suspense>
			{/* <Routes /> */}
		</div>
	);
}

export default App;
